// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"c5216448","295":"ecaf36af","453":"8a6a4024"}[chunkId] + ".chunk.js";
};